import { authAddUrl, getURLParam } from '@/assets/js/utils/utils'
import { queryUserInfo } from '@/assets/js/api/cloud'
import local from '@/assets/js/utils/local'

const state = {
  userInfo:'',
  isLoginIng: true,
  needLogin: JSON.parse(window.localStorage.getItem('needLogin')),
}

const mutations = {
  setUserInfo (state, obj) {
    state.userInfo = obj
  },
  setIsLoginIng (state, bl) {
    state.isLoginIng=bl
  },
  setNeedLogin (state, bl) {
    state.needLogin = bl
    local.setItem('needLogin', bl)
  },
}
const actions = {
  // 基础平台登录
  getUserInfo ({ commit, state }) {
    const { userInfo, isLoginIng, needLogin } = state
    const code = getURLParam().code
    const localUrl = code ? window.location.href.split('?')[0] : window.location.href
    // 有用户信息时，当前正在请求登录中，当前不需要登录时，都忽略
    if (userInfo) {
      return
    }
    if (code) {
      commit('setIsLoginIng', true)
      return queryUserInfo(code).then((res) => {
        if (res) {
       //   local.setItem('userInfo', res)
          // setTimeout(() => {
          //   window.location.href = localUrl
          // }, 100)
          commit('setUserInfo',res);
          commit('setIsLoginIng', false)
        }
        return res
      })
    } else {
      window.location.href = authAddUrl() + window.encodeURIComponent(localUrl)
    }
  },
  clearUserInfo ({ commit }) {
    local.removeItem('userInfo')
    commit('setUserInfo', null)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  modules: {},
}
